// v2.0.0 - 2026-02-02 - Configurations page using ConfigurationsList component

import { ConfigurationsList } from './configurations'

export default function ConfigurationsPage() {
  return <ConfigurationsList />
}
